var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"39","height":"20","viewBox":"0 0 39 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 10.5H36L27 1.5","stroke":"currentColor","stroke-width":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }